/**
 * dir-w | backOffice
 * Application Footer Component, contains information such as `copyrights` and `version`
 *
 * Last update : August 18, 2024 | @rizkiprasetya
 */

import { Component } from '@angular/core';
import { Configuration } from '../../config/configuration';
import { Subscription } from 'rxjs';
import { StatusBarService } from '../../services/status-bar.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css',
    standalone: false
})
export class FooterComponent {
  protected statusBarSubscription: Subscription;
  protected statusBarText: string = 'Ready . . .';

  configuration = Configuration;

  constructor(private _statusBarService: StatusBarService) {
    this.statusBarSubscription = this._statusBarService
      .getUpdate()
      .subscribe((message) => {
        this.statusBarText = message.text;
      });
  }
}